var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup632(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.606,
    height: 21,
    viewBox: "0 0 19.606 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(-1748 -185.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_52",
    "data-name": "Union 52",
    transform: "translate(1748 185.999)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.791,20.846l-2.609-1.468c-.257-.145-.56-.294-.813-.446a9.808,9.808,0,1,1,4.1-3.029c.075.24.139.5.205.743l.794,2.891a1.15,1.15,0,0,1-1.682,1.308Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.36178398132324 20.20000076293945 C 17.4680233001709 20.20000076293945 17.57720375061035 20.14348983764648 17.64671325683594 20.05253028869629 C 17.71420288085938 19.96421051025391 17.73270416259766 19.86173057556152 17.70220375061035 19.74967956542969 L 16.90821266174316 16.85976028442383 C 16.88545417785645 16.7775993347168 16.8629035949707 16.6924991607666 16.84007263183594 16.6063404083252 C 16.79830360412598 16.44865036010742 16.75511360168457 16.28558921813965 16.71022415161133 16.14215087890625 L 16.58333396911621 15.73672008514404 L 16.84814262390137 15.4045295715332 C 18.12873268127441 13.79806041717529 18.80562400817871 11.86038017272949 18.80562400817871 9.800979614257812 C 18.80562400817871 4.837820053100586 14.76533317565918 0.800000011920929 9.79914379119873 0.800000011920929 C 4.837003707885742 0.800000011920929 0.8000035285949707 4.837820053100586 0.8000035285949707 9.800979614257812 C 0.8000035285949707 14.7631196975708 4.837003707885742 18.80011940002441 9.79914379119873 18.80011940002441 C 10.93139362335205 18.80011940002441 12.03489398956299 18.59379959106445 13.0789737701416 18.18689918518066 L 13.44508361816406 18.04421997070312 L 13.78180313110352 18.24673080444336 C 13.91338348388672 18.32588005065918 14.07253360748291 18.41044044494629 14.22645378112793 18.49222946166992 C 14.3420934677124 18.55368041992188 14.46167373657227 18.61721992492676 14.57450389862061 18.68088912963867 L 17.18372344970703 20.1488094329834 C 17.24574279785156 20.18372917175293 17.30232429504395 20.20000076293945 17.36178398132324 20.20000076293945 M 17.36178398132324 21 C 17.17281341552734 21 16.98016357421875 20.95229911804199 16.79119300842285 20.84589004516602 L 14.18224334716797 19.37812042236328 C 13.92539310455322 19.23317909240723 13.6226634979248 19.08456993103027 13.36947345733643 18.93228912353516 C 12.26315307617188 19.36344909667969 11.05958366394043 19.60012054443359 9.79914379119873 19.60012054443359 C 4.386773586273193 19.60012054443359 3.529968353177537e-06 15.21518039703369 3.529968353177537e-06 9.800979614257812 C 3.529968353177537e-06 4.388609886169434 4.386773586273193 0 9.79914379119873 0 C 15.2170238494873 0 19.60562324523926 4.388609886169434 19.60562324523926 9.800979614257812 C 19.60562324523926 12.10902976989746 18.80753326416016 14.22994995117188 17.47370338439941 15.90320014953613 C 17.54892349243164 16.14353942871094 17.61314392089844 16.40773963928223 17.6791934967041 16.64624977111816 L 18.47361373901367 19.53774070739746 C 18.68644332885742 20.3193302154541 18.07181358337402 21 17.36178398132324 21 Z",
    stroke: "none",
    fill: "#444141"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1751.656 194.437)",
    fill: "#444141"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1756.302 194.437)",
    fill: "#444141"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1760.948 194.437)",
    fill: "#444141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup632);
export default __webpack_public_path__ + "static/media/Group 632.bf4f6fd4cbdb731f754f59501ecb6ab8.svg";
export { ForwardRef as ReactComponent };